/* eslint-disable no-undef */
import $HTTP from "../plugins/axios";
import store from "../store";
export default {
  methods: {
    async postFav(favorite_id, favorite_type, is_active) {
      if (this.$auth.isAuthenticated) {
        // this.$ga.event(favoriteType, "post", "favorite", 1);
        const params = {
          user_id: store.state.user.sub,
          favorite_id,
          favorite_type,
          is_active
        };
        const res = (await $HTTP.post("/userfavorite", params)).data
          .user_favorite;
        const type = is_active ? "success" : "error";
        const message = is_active ? "added" : "removed";
        this.$message({
          message: `Congrats, you ${message} this quote to your favorites.`,
          type
        });
        return res;
      } else {
        this.$message({
          message: `Sign in to use this feature.`,
          type: "error"
        });
      }
    },
    async getFav(favoriteId, favoriteType) {
      if (this.$auth.isAuthenticated) {
        const url = `/userfavorite/favorite/${favoriteId}/type/${favoriteType}`;
        const isFavorite = (await $HTTP.get(url)).data.isFavorite;
        return isFavorite.length > 0 && isFavorite[0].is_active;
      }
    },
    async getFavs(favoriteType) {
      if (this.$auth.isAuthenticated) {
        const url = `/userfavorite/favorite/type/${favoriteType}`;
        const { favorites } = (await $HTTP.get(url)).data;
        const quotes = [];
        for (let fav of favorites) {
          let uri = `/quote/${fav.favorite_id}`;
          const { quote } = (await $HTTP.get(uri)).data;
          quote.favorite = true;
          uri = `/author/${quote.q_author_id}`;
          const { author } = (await $HTTP.get(uri)).data;

          quote.author = author;
          quote.name = author.name;
          quotes.push(quote);
        }
        return quotes;
      }
    },
    async getFavs2() {
      if (this.$auth.isAuthenticated) {
        const url = `/userfavorite/favorite/quote`;
        const { favorites } = (await $HTTP.get(url)).data;
        return favorites;
      }
    }
  }
};
